import { DatePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Meldung } from '@app/shared/classes/meldung';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';
import { rxResource } from "@angular/core/rxjs-interop";

@Component({
  selector: 'meldung-history-dialog',
  templateUrl: './meldung-history-dialog.component.html',
  imports: [
    DatePipe,
    TranslatePipe,
  ]
})
export class MeldungHistoryDialogComponent {
  private readonly backendService = inject(BackendService);

  readonly meldung = input<Meldung>();
  protected readonly historyEntries = rxResource({
    defaultValue: [],
    params: () => {
      const meldung = this.meldung();
      return meldung ? { meldung } : undefined;
    },
    stream: ({ params }) => this.backendService.listHistoryEntries(params.meldung)
  });
}
